export const isMobileAgent = /Mobi|Android|Tablet/i.test(navigator.userAgent)
